<script setup lang="ts">
import type { TokenStatus } from '#auth/composables/useLoginModal'
import { ToggleGroup, ToggleGroupItem } from '@forgd/ui-kit/toggle-group'

const model = defineModel<TokenStatus>({ default: 'listed' })

const tabs: { value: TokenStatus, label: string }[] = [
  { value: 'pre-tge', label: 'Pre-TGE' },
  { value: 'listed', label: 'Listed' },
  { value: 'no-token', label: 'I don’t have a Token' },
]
</script>

<template>
  <ToggleGroup
    v-model="model"
    preset="light"
    layout="fill"
    size="lg"
    class="w-full"
  >
    <ToggleGroupItem
      v-for="tab in tabs"
      :key="tab.value"
      :value="tab.value"
      class="text-xs font-semibold"
    >
      {{ tab.label }}
    </ToggleGroupItem>
  </ToggleGroup>
</template>
